import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageWrapperComponent } from 'app/components/ui-kit/page-components/page-wrapper/page-wrapper.component';
import { HeavyHeaderComponent } from 'app/components/ui-kit/typography/heavy-header/heavy-header.component';
import { PrimaryBtnComponent } from 'app/components/ui-kit/buttons/primary-btn/primary-btn.component';

@Component({
  selector: 'app-account-type',
  standalone: true,
  imports: [PageWrapperComponent, HeavyHeaderComponent, PrimaryBtnComponent, CommonModule],
  templateUrl: './account-type.component.html',
  styleUrl: './account-type.component.scss'
})
export class AccountTypeComponent {
  constructor(private router: Router) {}

  onSelect(type: string) {
    if (type === 'invited') {
      this.router.navigate(['/onboard/invited-party/invite-code']);
    } else {
      this.router.navigate(['/onboard/membership']);
    }
  }
}

